import { serializable, alias, primitive } from 'serializr';

export class ProductionData {
    @serializable(alias('revenue', primitive()))
    revenue?: number | null;

    @serializable(alias('revenue_unit', primitive()))
    revenueUnit?: string | null;

    @serializable(alias('total_weight', primitive()))
    totalWeight?: number | null;

    @serializable(alias('year', primitive()))
    year?: string;

    @serializable(alias('location_id', primitive()))
    locationId?: string;
}

